/**
 * NATIVE INSTRUMENTS SOUND PLAYER - nisp.js
 *
 * With built-in DOM structure that is dynamically injected (if you're too lazy to create your own).
 *
 * DEPENDENCIES:
 *  - expects soundManager2 to be loaded
 *  - expects jQuery to be loaded
 *
 * HOW TO USE:
 *  - adjust the defaultConfig to your needs, or pass your own config as argument to nisp.init()
 *  - if you want to use built-in ajax fetching, just call nisp.fetchSound() with your desired ID and possibly
 *    a URL of your stream (needed for mobile playback!!)
 *  - if you don't like the ajax fetching, but render out your objects, you can play them via nisp.playSound()
 *    (you'll have to figure out the desired object structure by looking at defaultConfig.ajaxParser)
 *  - enjoy yourself!
 *
 */
(function (nisp, $, undefined) {

    // PRE-LOADING INITIALIZATION
    //
    var PLAYER_HEIGHT = "80px";
    //var PLAY_ICON = "icon_play.png";
    //var PAUSE_ICON = "icon_pause.png";
    //var DEFAULT_BACKGROUND = "default-background.png";

    // the currently loaded soundmanager sound object
    var currentSound = null;
    // the currently loaded mediaItem to be played
    var currentItem = null;
    // index of current chapter
    var currentChapterId = null;
    // whether we're playing sound
    var noSoundPlaying = true;

    var hasBeenInitialized = false,
        isVisible = false;

    var initCallback = null;
    var stateCallback = null;

    // the player's default dom structure - to be injected if not already present
    var domContent = '<div class="container-fluid">\
	<div class="nisp-bar row">\
		<div class="col-lg-1 hidden-md hidden-sm hidden-xs"></div>\
		<div class="nisp-controls col-lg-2 col-md-3 col-sm-3 col-xs-6">\
			<a class="nisp-button" data-player-action="prev"><span id="nisp-button-prev" class="nisp-sprite nisp-button-prev"></span></a>\
			<a class="nisp-button" data-player-action="playpause"><span id="nisp-button-playpause" class="nisp-sprite nisp-button-playpause pause"></span></a>\
			<a class="nisp-button" data-player-action="next"><span id="nisp-button-next" class="nisp-sprite nisp-button-next"></span></a>\
		</div>\
\
		<div class="nisp-waveformContainer col-lg-3 col-md-3 hidden-sm hidden-xs">\
			<div class="nisp-waveformText"><a class="nisp-itemLink"></a> - <span class="nisp-chapterLink">Title</span><span class="pull-right"></span></div>\
			<div class="nisp-waveform">\
				<div class="nisp-lineMarker"></div>\
				<div class="nisp-lineFlag"></div>\
				<!--<div class="nisp-positionMarker"></div>-->\
			</div>\
		</div>\
\
		<div class="nisp-textArea col-lg-4 col-md-4 col-sm-6 col-xs-4 hidden-xxs">\
			<p class="nisp-description">Description</p>\
		</div>\
\
		<!--<div class="nisp-controls-social col-lg-1 col-md-3 col-sm-3 hidden-xs">\
			<div class="pull-left">\
				<a class="nisp-button-horizontal nisp-button" data-player-action="deeplink"><img src="http://www.native-instruments.com/typo3conf/ext/ni_assets/Resources/Public/Images/nisp/icon_soundcloud.png"></a>\
				<a class="nisp-button-horizontal nisp-button" data-player-action="like"><img src="http://www.native-instruments.com/typo3conf/ext/ni_assets/Resources/Public/Images/nisp/icon_heart.png"></a>\
			</div>\
			<div class="pull-left">\
				<a class="nisp-button" data-player-action="share"><img src="http://www.native-instruments.com/typo3conf/ext/ni_assets/Resources/Public/Images/nisp/icon_share.png"></a>\
			</div>\
		</div>-->\
\
		<!--<div class="col-lg-1 hidden-md hidden-sm hidden-xs"></div>-->\
\
        <div class="nisp-smallDisplay hidden-lg hidden-md col-xs-12">\
            <div></div>\
            <div></div>\
        </div>\
\
		<div class="nisp-controls-right col-lg-2 col-md-1 col-sm-2 col-xs-1 pull-right">\
			<a class="nisp-button" data-player-action="hide"><span id="nisp-button-close" class="nisp-sprite nisp-button-close"></span></a>\
		</div>\
	</div>\
</div>';

    // default configuration object
    //
    var defaultConfig = {
        // the default volume (duh!)
        defaultVolume: 100,
        // location of background images (currently only used for the default background!)
        //imagePath: Util.getCdnDomain('img') + "/typo3conf/ext/ni_assets/Resources/Public/Images/nisp/",
        // the path to the soundManager2 swf files
        flashPath: "/typo3conf/ext/ni_assets/Resources/Public/Libs/soundmanager2/swf/",
        // the path to your Ajax endpoint
        ajaxPath: "/",
        // just leave it as false, except you want to see soundManager2's debug output (you don't)
        debugMode: false,
        // defines where DOM elements will be injected (if they are not present at nisp.init() runtime)
        domInjectionPath: "#player-container",

        /**
         * This function generates the arguments for the ajax call based on the ID that is passed into fetchSound().
         */
        ajaxData: function (id) {
            return {
                eID: "extbase",
                extensionName: "NiMedia",
                pluginName: "nimedia",
                controllerName: "Media",
                actionName: "ajax",
                media: id
            }
        },

        /**
         * This parses the ajax response to a mediaItem.
         */
        ajaxParser: function (response) {
            var data = $.parseJSON(response).data;
            var mediaItem = {};

            mediaItem.title = data.title;

            // take welcome screen background image for the player if available
            //try {
            //    var welcome = $(".welcome");
            //    mediaItem.backgroundImageUrl = welcome.css("background-image").match(/\(([^)]+)\)/)[1];
            //    $(".nisp-bar").css("background-size", "150%");
            //} catch (e) {
            //    // hard-coded for now!
            //    mediaItem.backgroundImageUrl = nisp.config.imagePath + DEFAULT_BACKGROUND;
            //    $(".nisp-bar").css("background-size", "100% 100%");
            //}

            mediaItem.deeplinkUrl = location.protocol + '//' + location.hostname + location.pathname + "?content=" + data.itemId;

            mediaItem.chapters = [];
            var chapterId;
            for (chapterId = 0; chapterId < data.chapters.length; ++chapterId) {
                var chapter = data.chapters[chapterId];
                var newChapter = {};
                newChapter.title = chapter.title;
                newChapter.description = chapter.description;
                newChapter.streamUrl = chapter.mediaHigh;
                newChapter.waveformUrl = chapter.waveform;

                mediaItem.chapters.push(newChapter);
            }

            return mediaItem;
        }
    };

    var eventHandlers = {};

    nisp.on = function(eventName, callback) {
        eventHandlers[eventName] = eventHandlers[eventName] || [];
        eventHandlers[eventName].push(callback);
    };

    nisp.once = function(eventName, callback) {
        nisp.on(eventName, function() {
            nisp.off(eventName, callback);
            callback.apply(null, arguments);
        });
    };

    nisp.off = function(eventName, callback) {
        if (eventHandlers[eventName]) {
            if (callback) {
                eventHandlers[eventName].splice(eventHandlers[eventName].indexOf(callback), 1);
            } else {}
            delete(eventHandlers[eventName]);
        }
    };

    nisp.emit = function(eventName) {
        if (eventHandlers[eventName]) {
            var args = Array.prototype.slice.call(arguments, 1);
            eventHandlers[eventName].forEach(function(callback) {
                callback.apply(null, args);
            });
        }
    };

    nisp.getState = function() {
        return {
            currentItem: currentItem,
            currentChapterId: currentChapterId,
            currentSound: currentSound
        }
    };

    // PUBLIC METHODS

    /**
     * This method triggers initialization of the sound engine (if it has not already happened). It takes a callback
     * and a configuration object as (optional) arguments, where the callback is just a reference to any function and the
     * configuration defines everything that is deployment-specific.
     *
     * To see what is expected as 'config', just take a look at the defaultConfig object defined above.
     */
    nisp.init = function (callback, config) {

        if (hasBeenInitialized) {
            if (typeof(callback) !== "undefined") {
                callback();
            }
            if (initCallback !== null) {
                initCallback();
            }
            return;
        } else {
            hasBeenInitialized = true;
        }

        config = config || defaultConfig;
        nisp.config = config;

        if ($(".nisp-bar").length == 0) {
            $(nisp.config.domInjectionPath).append(domContent);
        }

        $('a.nisp-itemLink').click(function (e) {
            e.preventDefault();
        });

        $('[data-player-action="playpause"]').click(function () {
            nisp.pauseOrPlay();
        });

        $('[data-player-action="next"]').click(function () {
            if (!($(this).hasClass("nisp-disabled"))) {
                nisp.emit('next');
                nisp.playItem(currentItem, ++currentChapterId);
            }
        });

        $('[data-player-action="prev"]').click(function () {
            if (!($(this).hasClass("nisp-disabled"))) {
                nisp.emit('prev');
                nisp.playItem(currentItem, --currentChapterId);
            }
        });

        $('[data-player-action="hide"]').click(function () {
            nisp.hidePlayer();
        });

        $(".nisp-waveform").click(function (event) {
            var pixelPos = event.pageX - $(this).offset().left;
            var relPos = pixelPos / $(this).width();
            var absPos = currentSound.duration * relPos;

            changeState('loading');
            soundManager.setPosition(currentSound.id, absPos);
            nisp.emit('seek', relPos);
        });

        // key support
        /*$(document).keydown(function (e) {
         if (e.keyCode == 27) {  // esc
         if (isVisible) {
         $('[data-player-action="hide"]').trigger('click');
         }
         }
         if (e.keyCode == 39) {  // next
         if (currentItem != null && isVisible && !($("input:focus").length)) {
         $('[data-player-action="next"]').trigger('click');
         }
         }
         if (e.keyCode == 37) {  // prev
         if (currentItem != null && isVisible && !($("input:focus").length)) {
         $('[data-player-action="prev"]').trigger('click');
         }
         }
         if (e.keyCode == 32) {  // space
         if (currentItem != null && isVisible && !($("input:focus").length)) {
         $('[data-player-action="playpause"]').trigger('click');
         e.preventDefault();
         }
         }
         });*/

        soundManager.setup({
            url: config.flashPath,
            flashVersion: 9,
            preferFlash: false, // prefer 100% HTML5 mode, where both supported
            ontimeout: function () {
                console.log('SM2 init failed!');
            },
            onready: function () {
                if (typeof(callback) !== "undefined") {
                    callback();
                }
                if (initCallback !== null) {
                    initCallback();
                }
            },
            defaultOptions: {
                volume: config.defaultVolume
            }
        });

    };

    /**
     * Lets you register a callback to be notified on state changes.
     *
     * Possible states are:
     *  - 'loading' playback has been triggered, but the sound file is still buffering
     *  - 'playing' sound is being played
     *  - 'paused'  sound file is buffered and ready to be played, but it's currently paused
     *  - 'stop'    the soundfile has been unloaded/player is hidden
     */
    nisp.statechange = function (callback) {
        // change last thumbnail back to default
        changeState('stop');
        stateCallback = callback;
    }

    /**
     * Lets you register a callback to be notified when initialization is complete.
     */
    nisp.ready = function (callback) {
        initCallback = callback;
        nisp.emit('ready', nisp);
    };

    /**
     * Returns a boolean that tells you whether the sound engine has been initalized successfully.
     */
    nisp.hasBeenInitialized = function () {
        return hasBeenInitialized;
    };

    /**
     * Takes a mediaItem object and a chapterId as parameters. Can be used to play already-fetched mediaItems.
     */
    nisp.playItem = function (mediaItem, chapterId) {
        currentItem = mediaItem;
        currentChapterId = chapterId;
        initMetaData();
        nisp.emit('play');
        playSound(currentItem.chapters[currentChapterId].streamUrl);
    };

    /**
     * Triggers an AJAX call to the backend as defined in the config. If streamUrl is defined, the stream will play
     * instantly while we're still waiting for the AJAX result.
     *
     * This should be your starting point if you just want to play media. If you want to change the way metadata is
     * collected, have a look at the defaultConfiguration at the top of this page.
     */
    nisp.fetchSound = function (id, streamUrl) {
        // instant playback
        if (typeof(streamUrl) !== "undefined") {
            playSound(streamUrl);
            $.get(
                nisp.config.ajaxPath, nisp.config.ajaxData(id), function (data) {
                    currentItem = nisp.config.ajaxParser(data);
                    currentChapterId = 0;
                    initMetaData();
                    nisp.emit('play');
                }
            );
        // fetch-first
        } else {
            $.get(
                nisp.config.ajaxPath, nisp.config.ajaxData(id), function (data) {
                    nisp.playItem(nisp.config.ajaxParser(data), 0);
                    nisp.emit('play');
                }
            );
        }
    };
    /**
     * Well, pause or play! Does whatever is right, depending on the situation. This way, we can bind a very simple
     * function to the click event of the play/pause button.
     */
    nisp.pauseOrPlay = function () {
        if (currentSound.paused) {
            changeState('loading');
            soundManager.resume(currentSound.id);
            nisp.emit('play');
        } else if (noSoundPlaying) {
            changeState('loading');
            nisp.playItem(currentItem, currentChapterId);
        } else {
            soundManager.pause(currentSound.id);
            changeState('paused');
            noSoundPlaying = true;
            nisp.emit('pause');
        }
    };

    /**
     * Simple wrapper for pauseOrPlay.
     */
    nisp.play = function () {
        if (!noSoundPlaying && currentSound.paused) {
            nisp.pauseOrPlay();
        }
    };

    /**
     * Simple wrapper for pauseOrPlay.
     */
    nisp.pause = function () {
        if (!noSoundPlaying && !currentSound.paused) {
            nisp.pauseOrPlay();
        }
    };

    /**
     * Stops playback and (hopefully, if GC is watching) unloads the sound file.
     */
    nisp.stop = function () {
        soundManager.stopAll();
        noSoundPlaying = true;
        currentSound = null;
        changeState('stop');
        nisp.emit('stop');
    };

    /**
     * Shows the interface (yay!)
     */
    nisp.showPlayer = function () {
        $('.nisp-lineMarker').show();
        $('.nisp-lineFlag').show();
        $('.nisp-waveformContainer').show();
        $('.nisp-smallDisplay').show();
        $('.nisp-bar').animate({height: PLAYER_HEIGHT});
        isVisible = true;
        nisp.emit('show');
    };

    /**
     * Hides the interface (buuh!)
     */
    nisp.hidePlayer = function () {
        nisp.stop();
        $('.nisp-lineMarker').hide();
        $('.nisp-lineFlag').hide();
        $('.nisp-bar').animate({height: '0px'});
        $('.nisp-waveformContainer').hide();
        $('.nisp-smallDisplay').hide();
        isVisible = false;
        nisp.emit('hide');
    };

    /**
     * iOS mobile devices interrupt "autostart" playing because no user interaction was triggert.
     * This function stops playing with *ugh* timeout.
     */
    nisp.iOsAutoplayFallback = function () {
        setTimeout(function () {
            jQuery("#nisp-button-playpause").removeClass('nisp-loading').addClass('play').removeClass('pause');
        }, 500);
    };

    // PRIVATE METHODS

    /**
     * Plays given stream. Only privately accessible - use mediaItems to play your sounds!
     */
    function playSound(streamUrl) {
        if (!noSoundPlaying) {
            soundManager.stopAll();
            noSoundPlaying = true;
            changeState('stop');
        }
        if (currentSound != null) {
            currentSound.destruct();
        }
        currentSound = soundManager.createSound({
            url: streamUrl
        });

        // show loading spinner
        changeState('playing');
        changeState('loading');

        soundManager.play(currentSound.id, {
            onload: function () {
                // change visible state
                if (noSoundPlaying) {
                    changeState('paused');
                } else {
                    changeState('playing');
                }
            },
            onsuspend: function () {
                // not yet used
            },
            whileplaying: function () {
                // adjust our noSoundPlaying variable
                if (noSoundPlaying && !currentSound.paused) {
                    noSoundPlaying = false;
                }

                // skip to current position
                $(".nisp-lineFlag, .nisp-smallDisplay div:first-child").text(formatCurrentPosition(this.position, currentSound.duration));
                $(".nisp-lineFlag").css("left", this.position / this.duration * $(".nisp-waveformContainer").width());
                $(".nisp-lineMarker").css("left", this.position / this.duration * $(".nisp-waveformContainer").width());

                // check if the user just skipped through waveform or sound is actually playing
                if (noSoundPlaying) {
                    changeState('paused');
                } else {
                    changeState('playing');
                    nisp.emit('progress', this.position / this.duration);
                }
            },
            onfinish: function () {
                noSoundPlaying = true;
                // more chapters in item?
                if (currentItem.chapters.length > currentChapterId + 1) {
                    // play next chapter
                    nisp.playItem(currentItem, ++currentChapterId);
                } else {
                    changeState('paused');
                }
            }
        });
    }

    /**
     * Manages appearance of play/pause button and propagates changes to thumbnails that registered a stateCallback
     */
    var lastState = "";
    function changeState(state) {
        // whileplaying triggers this method quite often. We don't need to trigger callbacks or DOM changes every time -
        // only when there's a new state.
        if (state == lastState) {
            return;
        } else {
            lastState = state;
        }

        // adjust player buttons
        if (state == "loading") {
            $("#nisp-button-playpause").addClass('nisp-loading');
        } else if (state == "playing") {
            $("#nisp-button-playpause").removeClass('nisp-loading').removeClass('play').addClass('pause');
        } else if (state == "paused") {
            $("#nisp-button-playpause").removeClass('nisp-loading').removeClass('pause').addClass('play');
        } else { // state == "stop"
            $("#nisp-button-playpause").removeClass('nisp-loading').addClass('play').removeClass('pause');
        }

        // propagate to callback
        if (stateCallback != null) {
            stateCallback(state);
        }
    }

    /**
     * This method separates the actual playing of a stream and the display of its mediaItem's/chapter's metadata.
     * The separation is used to play an mp3 stream instantly (important for Audio on mobile devices) while fetching
     * additional information in the background via AJAX.
     *
     * It basically reads the previously-fetched metadata and puts it into the corresponding elements of the sound
     * player's UI.
     */
    function initMetaData() {
        var currentChapter = currentItem.chapters[currentChapterId];

        // set title and description text
        $("a.nisp-itemLink").html(currentItem.title);
        $("a.nisp-itemLink").attr("href", currentItem.deeplinkUrl);
        $("span.nisp-chapterLink").html(currentChapter.title);
        $(".nisp-textArea p").html(currentChapter.description);

        // show track number
        $(".nisp-waveformText span.pull-right, .nisp-smallDisplay div:nth-child(2)").text(currentChapterId + 1 + "/" + currentItem.chapters.length);

        // en-/disable backward button
        if (currentChapterId > 0) {
            $('[data-player-action="prev"]').removeClass("nisp-disabled");
        } else {
            $('[data-player-action="prev"]').addClass("nisp-disabled");
        }

        // en-/disable forward button
        if (currentItem.chapters.length > currentChapterId + 1) {
            $('[data-player-action="next"]').removeClass("nisp-disabled");
        } else {
            $('[data-player-action="next"]').addClass("nisp-disabled");
        }

        // set background images
        //if (currentItem.backgroundImageUrl !== undefined && $(".nisp-bar").css("background-image").indexOf(currentItem.backgroundImageUrl) == -1) {
        //    $(".nisp-bar").css("background-image", "url(" + currentItem.backgroundImageUrl + ")");
        //}

        // set waveform image
        $(".nisp-waveform").css("background-image", "url(" + currentChapter.waveformUrl + ")");

        // show player bar
        nisp.showPlayer();
        nisp.emit('metadataLoaded');
    }

    // HELPER FUNCTIONS

    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    function formatCurrentPosition(position, duration) {
        var posMinutes = Math.floor(position / 1000 / 60);
        var posSeconds = Math.floor(position / 1000) - posMinutes * 60;
        var durMinutes = Math.floor(duration / 1000 / 60);
        var durSeconds = Math.floor(duration / 1000) - durMinutes * 60;
        var remMinutes = durMinutes - posMinutes;
        var remSeconds;
        if (durSeconds < posSeconds) {
            remMinutes--;
            remSeconds = 60 - posSeconds + durSeconds;
        } else {
            remSeconds = durSeconds - posSeconds;
        }
        //return posMinutes + ":" + pad(posSeconds, 2, "0") + "/" + durMinutes + ":" + durSeconds;
        return "-" + pad(remMinutes, 2, "0") + ":" + pad(remSeconds, 2, "0");
    }

    jQuery(window).trigger('nisp', nisp);

}(window.nisp = window.nisp || {}, jQuery));
